import { CircumstancesType } from "../constants";
import { IProfileMood } from "../contexts/Auth/Auth";
import { updateProfileMoodPassportData } from "../services/NetworkManager";
import { Store } from "./Storage";
import { isSameDate } from "./date.utils";

export const mapStoreDataToProfileFields = (
  store: Partial<Store>,
  circumstancesData: CircumstancesType[]
) => {
  return {
    family_name: store?.family_name ?? "",
    given_name: store?.given_name ?? "",
    email: store?.email ?? "",
    profile_nickname: store?.profile_nickname ?? "",
    profile_dob: store?.profile_dob ?? "",
    profile_gp_details: store?.profile_gp_details ?? "",
    profile_support_network: store?.profile_support_network ?? "",
    profile_support_services: store?.profile_support_services ?? "",
    profile_work: store?.profile_work ?? "",
    gender: store?.gender ?? "",
    circumstances: circumstancesData,
    profile_university: store?.profile_university ?? "",
    profile_course: store?.profile_course ?? "",
    profile_contacts: store?.profile_contacts ?? "",
  };
};

export const getSomeProfileDataForRasa = (data: Partial<Store>, circumstancesData: CircumstancesType[]) => {
  const {
    family_name,
    email,
    profile_gp_details,
    profile_support_network,
    profile_support_services,
    profile_work,
    profile_contacts,
    profile_dob,
    profile_university,
    ...restData
  } = mapStoreDataToProfileFields(data, circumstancesData);

  return restData;
};

export const settingTheProfileMood = async (
  id: string,
  mood: string,
  profileMood: IProfileMood[]
) => {
  if (mood) {
    const currentDate = Date.now();
    const lastStoredMood = profileMood[profileMood.length - 1];
    if (lastStoredMood) {
      if (isSameDate(currentDate, lastStoredMood.date)) {
        return profileMood;
      }
    }

    const newUpdatedMoods = [
      ...profileMood.map(({ mood, date }) => ({ mood, date })), // Remove __typename
      { mood, date: currentDate }, // Add new mood
    ];
		const response = await updateProfileMoodPassportData({
			id: id,
			profile_mood: newUpdatedMoods,
		});

    return response.profile_mood;
  }
};

export const university_data = [
  { "value": "ACM", "label": "Academy of Contemporary Music (London)" },
  { "value": "AED", "label": "ArtsEd" },
  { "value": "ARC", "label": "Anglia Ruskin Chelmsford" },
  { "value": "ARCB", "label": "Anglia Ruskin Cambridge" },
  { "value": "ARU", "label": "Anglia Ruskin University London" },
  { "value": "ASM", "label": "Staff Academy of Medical Sciences" },
  { "value": "AST", "label": "Aston University" },
  { "value": "ATW", "label": "Access to Work" },
  { "value": "AUB", "label": "Arden University Birmingham" },
  { "value": "AUE", "label": "Arden University Ealing" },
  { "value": "AUH", "label": "Arden University Holborn" },
  { "value": "AUM", "label": "Arden University Manchester" },
  { "value": "AUT", "label": "Arden University Towerhill" },
  { "value": "AUW", "label": "Aberystwyth University" },
  { "value": "BAN", "label": "Bangor University, Bangor" },
  { "value": "BBK", "label": "Birkbeck" },
  { "value": "BC", "label": "Blackburn College" },
  { "value": "BCU", "label": "Birmingham City University" },
  { "value": "BED", "label": "University of Bedfordshire" },
  { "value": "BHM", "label": "University of Birmingham" },
  { "value": "BIL", "label": "Bloomsbury Institute" },
  { "value": "BIMM", "label": "The British and Irish Modern Music Institute Brighton" },
  { "value": "BLG", "label": "Big Life Group" },
  { "value": "BMA", "label": "Arts University Bournemouth" },
  { "value": "BMU", "label": "Bournemouth University" },
  { "value": "BNU", "label": "Buckinghamshire New University" },
  { "value": "BNULSST", "label": "Buckinghamshire New University part of LSST" },
  { "value": "BPP", "label": "BPP Professional Education" },
  { "value": "BRI", "label": "University of Brighton" },
  { "value": "BRU", "label": "Brunel University London" },
  { "value": "BTH", "label": "University of Bath" },
  { "value": "CCC", "label": "Canterbury Christ Church" },
  { "value": "CDF", "label": "Cardiff University" },
  { "value": "CFS", "label": "Central Film School" },
  { "value": "CGLAS", "label": "City & Guilds of London Art School" },
  { "value": "CHU", "label": "Chester University" },
  { "value": "CIA", "label": "Courtauld Institute of Art" },
  { "value": "COE", "label": "College of Esports" },
  { "value": "CSSD", "label": "Royal Central School of Speech & Drama" },
  { "value": "CU", "label": "City University" },
  { "value": "CUC", "label": "Cranfield University Cranfield" },
  { "value": "CUCC", "label": "Coventry University Coventry Campus" },
  { "value": "CULC", "label": "Coventry University London Campus" },
  { "value": "CUM", "label": "University of Cumbria" },
  { "value": "DGHE", "label": "David Game Higher Education" },
  { "value": "DIT", "label": "Department for International Trade" },
  { "value": "DUR", "label": "Durham University" },
  { "value": "EC", "label": "EC London" },
  { "value": "EDB", "label": "University of Edinburgh" },
  { "value": "EH", "label": "Edge Hill" },
  { "value": "ENU", "label": "Edinburgh Napier" },
  { "value": "EXE", "label": "University of Exeter" },
  { "value": "FRA", "label": "Fashion Retail Academy" },
  { "value": "GBS", "label": "Global Banking School" },
  { "value": "GCS", "label": "Gower College Swansea" },
  { "value": "GHSMD", "label": "Guildhall" },
  { "value": "GLA", "label": "Glasgow University" },
  { "value": "GRE", "label": "University of Greenwich" },
  { "value": "GS", "label": "Goldsmiths" },
  { "value": "GSA", "label": "Glasgow School of Arts" },
  { "value": "GSM", "label": "GSM London" },
  { "value": "GW", "label": "Greenwich" },
  { "value": "HAISAI", "label": "Haisai" },
  { "value": "HAR", "label": "Hartpury University" },
  { "value": "HAU", "label": "Harper Adams University" },
  { "value": "HEY", "label": "Heythrop College" },
  { "value": "HMT", "label": "HM Treasury" },
  { "value": "HUD", "label": "University of Huddersfield" },
  { "value": "HUL", "label": "University of Hull" },
  { "value": "HWU", "label": "Heriot-Watt University" },
  { "value": "IC", "label": "Imperial College" },
  { "value": "ICMP", "label": "The Institute of Contemporary Music Performance" },
  { "value": "ICON", "label": "Icon College London" },
  { "value": "KCL", "label": "Kings College London" },
  { "value": "KSA", "label": "Kingston School of Art" },
  { "value": "KUL", "label": "Kingston University London" },
  { "value": "LAMDA", "label": "The London Academy of Music and Dramatic Art" },
  { "value": "LAU", "label": "Leeds Art University" },
  { "value": "LBC", "label": "London Borough Of Camden" },
  { "value": "LBF", "label": "London Institute of Banking and Finance" },
  { "value": "LBORO", "label": "Loughborough" },
  { "value": "LBU", "label": "Leeds Beckett University" },
  { "value": "LC", "label": "London College" },
  { "value": "LCCA", "label": "London College of Contemporary Arts (LCCA)" },
  { "value": "LCCU", "label": "Leeds City College University" },
  { "value": "LCF", "label": "London College Of Fashion" },
  { "value": "LCN", "label": "University of Lincoln" },
  { "value": "LHU", "label": "Liverpool Hope University" },
  { "value": "LIV", "label": "The University of Liverpool" },
  { "value": "LJM", "label": "Liverpool John Moores" },
  { "value": "LMA", "label": "LMA Liverpool" },
  { "value": "LMU", "label": "London Metropolitan University" },
  { "value": "LPA", "label": "Liverpool Institute of Performing Arts" },
  { "value": "LSBM", "label": "London School of Business and Management" },
  { "value": "LSBU", "label": "London South Bank" },
  { "value": "LSC", "label": "London School of Commerce" },
  { "value": "LSE", "label": "London School of Economics" },
  { "value": "LSEG", "label": "London Stock Exchange" },
  { "value": "LSES", "label": "London School of Economics - Supervision" },
  { "value": "LSHTM", "label": "London School of Hygiene & Tropical Medicine" },
  { "value": "LSME", "label": "London School of Management Education Awarded by the University of Chichester" },
  { "value": "LSST", "label": "London School of Science and Technology" },
  { "value": "LSTC", "label": "London Studio Centre" },
  { "value": "LTU", "label": "Leeds Trinity University" },
  { "value": "MAN", "label": "University of Manchester" },
  { "value": "MDX", "label": "Middlesex University" },
  { "value": "MET", "label": "London Metropolitan University" },
  { "value": "MFS", "label": "Met Film School" },
  { "value": "MI", "label": "Metanoia Institute" },
  { "value": "MRC", "label": "Mont Rose College" },
  { "value": "MTV", "label": "Mountview" },
  { "value": "NAM", "label": "Nottinghill Academy of Music" },
  { "value": "NCC", "label": "New City College" },
  { "value": "NCU", "label": "Newcastle College - University Centre" },
  { "value": "NESCOT", "label": "North East Surrey College of Technology" },
  { "value": "NFTS", "label": "National Film and Television School" },
  { "value": "NLC", "label": "Norland College" },
  { "value": "NOR", "label": "University of Northampton" },
  { "value": "NSA", "label": "The Northern School of Art" },
  { "value": "NSPC", "label": "The New School of Psychotherapy and Counselling" },
  { "value": "NTU", "label": "Nottingham Trent University" },
  { "value": "NU", "label": "Northumbria University" },
  { "value": "NUA", "label": "Norwich University of the Arts" },
  { "value": "NUL", "label": "Northumbria University London" },
  { "value": "NUN", "label": "Northumbria University" },
  { "value": "NWU", "label": "Newcastle University" },
  { "value": "OAC", "label": "Open Art College" },
  { "value": "ONS", "label": "Office for National Statistics" },
  { "value": "OPEN", "label": "Open University" },
  { "value": "OU", "label": "Open University" },
  { "value": "OXB", "label": "Oxford Brookes" },
  { "value": "PBMS", "label": "Point Blank Music School" },
  { "value": "PCL", "label": "Pearson College London" },
  { "value": "PLY", "label": "University of Plymouth" },
  { "value": "POR", "label": "University of Portsmouth" },
  { "value": "PRI", "label": "Private" },
  { "value": "QMUL", "label": "Queen Mary" },
  { "value": "RADA", "label": "Royal Academy of Dramatic Art" },
  { "value": "RAV", "label": "Ravensbourne" },
  { "value": "RBC", "label": "Rose Bruford College" },
  { "value": "RCA", "label": "RCA" },
  { "value": "RCM", "label": "Royal College of Music" },
  { "value": "REL", "label": "Republic London" },
  { "value": "RHUL", "label": "Royal Holloway" },
  { "value": "ROE", "label": "University of Roehampton London" },
  { "value": "RTS", "label": "Right to Succeed" },
  { "value": "RUL", "label": "Regent's University London" },
  { "value": "RVC", "label": "RVC" },
  { "value": "SAE", "label": "SAE Institute" },
  { "value": "SAL", "label": "University of Salford" },
  { "value": "SCC", "label": "Schumacher College" },
  { "value": "SCW", "label": "Sparsholt College Winchester" },
  { "value": "SEU", "label": "South Essex University" },
  { "value": "SFU", "label": "Staffordshire University" },
  { "value": "SGUL", "label": "St Georges University London" },
  { "value": "SHL", "label": "Shelter’s People of Colour Affinity Group" },
  { "value": "SHU", "label": "Sheffield Hallam University" },
  { "value": "SMU", "label": "St Mary’s University Twickenham" },
  { "value": "SOAS", "label": "School of Oriental & African Studies" },
  { "value": "SPC", "label": "St Patrick College" },
  { "value": "SPTI", "label": "Sherwood Psychotherapy Training Institute" },
  { "value": "SSX", "label": "University of Sussex" },
  { "value": "STL", "label": "University of Stirling" },
  { "value": "SU", "label": "Solent University" },
  { "value": "SUF", "label": "University of Suffolk" },
  { "value": "SUNSTAR", "label": "Sunstar Gum" },
  { "value": "SUR", "label": "University of Surrey" },
  { "value": "SWA", "label": "Swansea University" },
  { "value": "TCK", "label": "Tresham College Kettering" },
  { "value": "TCP", "label": "The Clare Project" },
  { "value": "TEE", "label": "Teesside University" },
  { "value": "TES", "label": "TES Institute" },
  { "value": "TLC", "label": "Trinity Laban Conservatoire" },
  { "value": "TSL", "label": "Tileyard Studios London" },
  { "value": "UAL", "label": "University of Arts London" },
  { "value": "UAL-CCW", "label": "UAL - Camberwell College of Arts" },
  { "value": "UAL-LCF", "label": "UAL - London College Of Fashion" },
  { "value": "UCA", "label": "University for the Creative Arts Farnham" },
  { "value": "UCAB", "label": "University Centre Askham Bryan" },
  { "value": "UCC", "label": "University Centre Croydon" },
  { "value": "UCFB", "label": "University Campus of Football Business" },
  { "value": "UCL", "label": "UCL" },
  { "value": "UCLAN", "label": "University of Central Lancashire" },
  { "value": "UCLBAME", "label": "University College London" },
  { "value": "UCO", "label": "University College of Osteopathy" },
  { "value": "UD", "label": "University of Derby" },
  { "value": "UEA", "label": "University of East Anglia" },
  { "value": "UEL", "label": "University of East London" },
  { "value": "UKCBC", "label": "UK College of Business and Computing" },
  { "value": "UKT", "label": "University of Kent" },
  { "value": "ULB", "label": "University of Law Bloomsbury" },
  { "value": "ULM", "label": "University of Law Moorgate" },
  { "value": "UMO", "label": "UMO" },
  { "value": "UOB", "label": "University of Bristol" },
  { "value": "UOC", "label": "University of Chichester" },
  { "value": "UOE", "label": "University of Essex" },
  { "value": "UOG", "label": "University of Gloucestershire" },
  { "value": "UOH", "label": "University of Hertfordshire" },
  { "value": "UOK", "label": "Keele University" },
  { "value": "UOL", "label": "University of Leeds" },
  { "value": "UON", "label": "University of Nottingham" },
  { "value": "UOO", "label": "University of Oxford" },
  { "value": "UOR", "label": "University of Reading" },
  { "value": "UOS", "label": "University of Sheffield" },
  { "value": "UOW", "label": "University of Warwick" },
  { "value": "UOY", "label": "University of York" },
  { "value": "USH", "label": "University of Southampton" },
  { "value": "USL", "label": "University Sunderland London" },
  { "value": "USS", "label": "University Sunderland" },
  { "value": "USW", "label": "University of South Wales" },
  { "value": "UTH", "label": "University of Southampton" },
  { "value": "UWE", "label": "University of the West of England - UWE Bristol" },
  { "value": "UWL", "label": "University of West London" },
  { "value": "UWS", "label": "University West of Scotland London Campus" },
  { "value": "UWTSD", "label": "University of Wales Trinity Saint David" },
  { "value": "WDCAC", "label": "West Dean College of Arts and Conservation" },
  { "value": "WGU", "label": "Wrexham Glyndwr University" },
  { "value": "WIN", "label": "University of Winchester" },
  { "value": "WLC", "label": "Ealing, Hammersmith & West London College" },
  { "value": "WLV", "label": "University of Wolverhampton" },
  { "value": "WOR", "label": "University of Worcester" },
  { "value": "WUL", "label": "Westminster University London" }
];
